export var ILoginRequest;
(function (ILoginRequest) {
    let IAdditionalSSOData;
    (function (IAdditionalSSOData) {
        /**
         * Return an instance of IAdditionalSSOData with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IAdditionalSSOData.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IAdditionalSSOData = ILoginRequest.IAdditionalSSOData || (ILoginRequest.IAdditionalSSOData = {}));
    let IIosAppAttestData;
    (function (IIosAppAttestData) {
        /**
         * Return an instance of IIosAppAttestData with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IIosAppAttestData.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IIosAppAttestData = ILoginRequest.IIosAppAttestData || (ILoginRequest.IIosAppAttestData = {}));
    let IGooglePlayDeviceIntegrityData;
    (function (IGooglePlayDeviceIntegrityData) {
        let IntegrityTokenMissingReason;
        (function (IntegrityTokenMissingReason) {
            IntegrityTokenMissingReason["INTEGRITY_TOKEN_MISSING_REASON_UNKNOWN"] = "INTEGRITY_TOKEN_MISSING_REASON_UNKNOWN";
            /**
             * The app wasn't able to fetch the nonce from the backend
             */
            IntegrityTokenMissingReason["NONCE_QUERY_FAILED"] = "NONCE_QUERY_FAILED";
            /**
             * Reason from Google is "The calling app UID (user id) does not match the one from Package Manager.
             * Something is wrong (possibly an attack). Non-actionable."
             */
            IntegrityTokenMissingReason["ATTACK_SUSPECTED_BY_GOOGLE_SERVICES"] = "ATTACK_SUSPECTED_BY_GOOGLE_SERVICES";
            IntegrityTokenMissingReason["NETWORK_ERROR"] = "NETWORK_ERROR";
            IntegrityTokenMissingReason["GOOGLE_SERVER_ERROR"] = "GOOGLE_SERVER_ERROR";
            /**
             * Most likely old play store version
             */
            IntegrityTokenMissingReason["COULD_NOT_CONNECT_TO_PLAY_STORE"] = "COULD_NOT_CONNECT_TO_PLAY_STORE";
            /**
             * Similar to the above; IntegrityService : Binder has died
             */
            IntegrityTokenMissingReason["BINDER_HAS_DIED"] = "BINDER_HAS_DIED";
            /**
             * We have reached capacity for out google services allowance
             */
            IntegrityTokenMissingReason["THROTTLED_BY_GOOGLE_SERVICES"] = "THROTTLED_BY_GOOGLE_SERVICES";
            /**
             * We could not fetch the token in time for the user reaching the login page + 5 seconds
             */
            IntegrityTokenMissingReason["TIMED_OUT_WAITING_FOR_GOOGLE"] = "TIMED_OUT_WAITING_FOR_GOOGLE";
            /**
             * Something else went wrong
             */
            IntegrityTokenMissingReason["OTHER"] = "OTHER";
        })(IntegrityTokenMissingReason = IGooglePlayDeviceIntegrityData.IntegrityTokenMissingReason || (IGooglePlayDeviceIntegrityData.IntegrityTokenMissingReason = {}));
        /**
         * Return an instance of IGooglePlayDeviceIntegrityData with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IGooglePlayDeviceIntegrityData.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IGooglePlayDeviceIntegrityData = ILoginRequest.IGooglePlayDeviceIntegrityData || (ILoginRequest.IGooglePlayDeviceIntegrityData = {}));
    let IHCaptchaData;
    (function (IHCaptchaData) {
        let HCaptchaError;
        (function (HCaptchaError) {
            HCaptchaError["H_CAPTCHA_ERROR_UNKNOWN"] = "H_CAPTCHA_ERROR_UNKNOWN";
            /**
             * hCaptcha token fetch promise not initialised before user attempted login
             */
            HCaptchaError["NO_PROMISE"] = "NO_PROMISE";
            /**
             * Calling hCaptcha API failed
             */
            HCaptchaError["NO_RESPONSE"] = "NO_RESPONSE";
            /**
             * hCaptcha script did not load
             */
            HCaptchaError["NO_SCRIPT"] = "NO_SCRIPT";
            /**
             * hCaptcha returned an undefined token
             */
            HCaptchaError["NO_TOKEN"] = "NO_TOKEN";
            /**
             * No widget ID was set when an API call was attempted
             */
            HCaptchaError["NO_WIDGET"] = "NO_WIDGET";
            /**
             * Widget element failed to render
             */
            HCaptchaError["RENDER_FAIL"] = "RENDER_FAIL";
            /**
             * Setting read as off for this user
             */
            HCaptchaError["SETTING_OFF"] = "SETTING_OFF";
            /**
             * hCaptcha token fetch timed out
             */
            HCaptchaError["TIMED_OUT"] = "TIMED_OUT";
            /**
             * We waited too long to submit the token
             */
            HCaptchaError["TOKEN_EXPIRED"] = "TOKEN_EXPIRED";
            /**
             * The code path calling the login endpoint is not requesting hCaptcha
             */
            HCaptchaError["UNCOVERED_FLOW"] = "UNCOVERED_FLOW";
        })(HCaptchaError = IHCaptchaData.HCaptchaError || (IHCaptchaData.HCaptchaError = {}));
        /**
         * Return an instance of IHCaptchaData with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IHCaptchaData.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
    })(IHCaptchaData = ILoginRequest.IHCaptchaData || (ILoginRequest.IHCaptchaData = {}));
    /**
     * Return an instance of ILoginRequest with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    ILoginRequest.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(ILoginRequest || (ILoginRequest = {}));
